module.exports = __webpack_public_path__ + "img/distance.f007dc34.svg";